import type { SupplierMeasurementEquipment } from '@tandemone/types'

export type MeasurementFamily = 'dimensional' | 'hardness' | 'material' | 'ndt'

export type MeasurementFamilyInfo = {
  family: MeasurementFamily
  label: string
}

const FAMILY_LABELS: Record<MeasurementFamily, string> = {
  dimensional: 'Dimensional & profile',
  hardness: 'Hardness',
  material: 'Material analysis',
  ndt: 'NDT & environmental'
}

const FAMILY_DOT_CLASSES: Record<MeasurementFamily, string> = {
  dimensional: 'bg-cyan-400',
  hardness: 'bg-violet-400',
  material: 'bg-lime-400',
  ndt: 'bg-pink-400'
}

const FAMILY_BY_EQUIPMENT: Record<
  SupplierMeasurementEquipment,
  MeasurementFamily
> = {
  cmm: 'dimensional',
  optical_comparator: 'dimensional',
  surface_finish: 'dimensional',
  calipers_micrometers: 'dimensional',
  microscope: 'dimensional',
  hardness_testing: 'hardness',
  micro_hardness_testing: 'hardness',
  spectrograph: 'material',
  chemical: 'material',
  x_ray: 'material',
  magnetic_particle: 'ndt',
  penetrant: 'ndt',
  salt_spray_tester: 'ndt'
}

export function getMeasurementFamily(
  equipment: SupplierMeasurementEquipment
): MeasurementFamilyInfo {
  const family = FAMILY_BY_EQUIPMENT[equipment]
  return {
    family,
    label: FAMILY_LABELS[family]
  }
}

export const MEASUREMENT_FAMILY_LABELS = FAMILY_LABELS
export const MEASUREMENT_FAMILY_DOT_CLASSES = FAMILY_DOT_CLASSES

export const MEASUREMENT_FAMILY_ORDER: ReadonlyArray<MeasurementFamily> = [
  'dimensional',
  'hardness',
  'material',
  'ndt'
]
